
import * as THREE from 'three';
import { ThreeView } from '../view3d/webcad/View3dWebCad';
import { PointInfo } from './WalltoFittingInfo';

export class CreateObject {

    constructor() {

    }

    // ボックスの作成
    static createBoxGrometry(width: number, height: number, depth: number, _color: THREE.Color): THREE.Mesh {
        const box = new THREE.BoxGeometry(width, height, depth);
        const material = new THREE.MeshStandardMaterial({
            color: _color
        });
        return new THREE.Mesh(box, material);
    }
    
    // 壁からラインオブジェクトを作成
    static createWallLine(width: number, matrix: THREE.Matrix4, offsetY: number): THREE.LineSegments {
        const start = new THREE.Vector3(-width/2, offsetY, 0);
        const end = new THREE.Vector3(width/2, offsetY, 0);
        const line = new THREE.Line3(start, end);
        line.applyMatrix4(matrix);

        const points = [];
        points.push( line.start );
        points.push( line.end );
        
        const lineObject = this.createLine(points, new THREE.Color('#F2F2F2'));

        return lineObject;
    }
    
    // ラインを作成して表示
    static createLine(points: THREE.Vector3[], color_: THREE.Color): THREE.LineSegments {
        const geometry = new THREE.BufferGeometry().setFromPoints( points );
        const object = new THREE.LineSegments(
            geometry, 
            new THREE.LineBasicMaterial({color: color_})
        );

        return object;
    }

    // ポイントリストの最小値と最大値からboxを作成する
    static createBox(pointList: PointInfo[]): THREE.Box3 {
        const min = new THREE.Vector3();
        const max = new THREE.Vector3();
        for (let i = 0; i < pointList.length; i++) {
            min.min(pointList[i].point);
            max.max(pointList[i].point);
        }

        return new THREE.Box3(min, max);
    }

}